import { render, staticRenderFns } from "./footer-quick-access.vue?vue&type=template&id=02e481f1&"
import script from "./footer-quick-access.vue?vue&type=script&lang=js&"
export * from "./footer-quick-access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports